import { vars } from "plos/src/styles";
import { style } from "@vanilla-extract/css";

export const matchesH2HMainContent = style({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: vars.space.m,
});
